export default __webpack_public_path__ + "static/media/735.48269cec.png";